import { render, staticRenderFns } from "./ChooseLecturer.vue?vue&type=template&id=2def8042"
import script from "./ChooseLecturer.vue?vue&type=script&lang=js"
export * from "./ChooseLecturer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports